module.exports = __webpack_public_path__ + "static/media/shop.81086630.svg";